import { useEffect, useState } from "react";

import { Image } from "@modules/blog/types";
import { ApiEndpoint } from "@constants/index";

import { IRecipeInstructions } from "@pages/RecipeMutation/helper/types";

export const useRenderFileViewHook = (
  newList: FileList | null,
  existingImages: Image[]
) => {
  const [previews, setPreviews] = useState<string[] | []>([]);

  const existingImagesUrls = existingImages?.map((item) => `${ApiEndpoint}/${item.url}`) || []

  useEffect(() => {
    const alreadyUploadedImage = !(newList instanceof FileList);

    if (alreadyUploadedImage) {
      // There are not uploaded files
      setPreviews(existingImagesUrls || [])

      return
    }

    const promises = Object.values(newList).map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          resolve(reader.result);
        };

        reader.readAsDataURL(file);
      });
    });

    Promise.all(promises)
      .then((results: unknown) => {
        if (Array.isArray(results)) {
          const filteringDontSaveSameBase64result = results
            .reduce((prev, next) => {
              if (prev.includes(next)) {
                return prev
              }

              return [...prev, next]
            }, [])

          setPreviews([
            ...filteringDontSaveSameBase64result as string[],
            ...existingImagesUrls
          ]);
        }
      })
  }, [newList, existingImages]);

  if (!previews?.length) {
    return [];
  }

  return previews
};

export const useRenderFileViewForAllInstructions = (instructions: IRecipeInstructions[]) => {
  const [previews, setPreviews] = useState<Record<string, string[]>>({});

  useEffect(() => {
    instructions.forEach(({ id: instId, existingImages, uploadedFiles }) => {
      const existingImagesUrls = existingImages?.map((item) => `${ApiEndpoint}/${item.url}`) || []
      const alreadyUploadedImage = !(uploadedFiles instanceof FileList);

      if (alreadyUploadedImage) {
        // There are not uploaded files
        setPreviews((prev) => {
          return {
            ...prev,
            [instId]: existingImagesUrls
          }
        })
      }

      const promises = Object.values(uploadedFiles || []).map((file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();

          reader.onloadend = () => {
            resolve(reader.result);
          };

          reader.readAsDataURL(file);
        });
      });

      Promise.all(promises)
        .then((results: unknown) => {
          if (Array.isArray(results)) {
            const filteringDontSaveSameBase64result = results
              .reduce((prev, next) => {
                if (prev.includes(next)) {
                  return prev
                }

                return [...prev, next]
              }, [])

            setPreviews((prev) => {
              return {
                ...prev,
                [instId]: [
                  ...filteringDontSaveSameBase64result as string[],
                  ...existingImagesUrls
                ]
              }
            })
          }
        })
    })
  }, [JSON.stringify(instructions)]);

  return previews
};
